import { RetroShareStatus } from "@safetyculture/s12-apis-connect-web/s12/templates/v1/template_retroshare_pb";

export const RetroShareStatuses = [
  {
    id: "applying",
    value: RetroShareStatus.APPLYING,
    label: "Applying",
  },
  {
    id: "cancelled",
    value: RetroShareStatus.CANCELLED,
    label: "Cancelled",
  },
  {
    id: "cancelledpending",
    value: RetroShareStatus.CANCELLED_PENDING,
    label: "Cancelled pending",
  },
  {
    id: "complete",
    value: RetroShareStatus.COMPLETE,
    label: "Complete",
  },
  {
    id: "discovering",
    value: RetroShareStatus.DISCOVERING,
    label: "Discovering",
  },
  {
    id: "expired",
    value: RetroShareStatus.EXPIRED,
    label: "Expired",
  },
  {
    id: "failed",
    value: RetroShareStatus.FAILED,
    label: "Failed",
  },
  {
    id: "inprogress",
    value: RetroShareStatus.IN_PROGRESS,
    label: "In progress",
  },
  {
    id: "pending",
    value: RetroShareStatus.PENDING,
    label: "Pending",
  },
  {
    id: "unspecified",
    value: RetroShareStatus.UNSPECIFIED,
    label: "Unspecified",
  },
];

export const RetroShareStatusMap = new Map<RetroShareStatus, string>();
RetroShareStatuses.forEach((status) => {
  RetroShareStatusMap.set(status.value, status.label);
});
